export default {
  backgroundColor: 'none',
  minHeight: 'calc(100vh - 235px)'
}



// WEBPACK FOOTER //
// ./src/styles/tabs/bar.js